// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CorrectiveMaintenanceActionTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceActionTypeApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceActionTypeDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-action-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
